import {
    PermitAssignmentsActionTypes,
    LOAD_PERMIT_REGISTER_USERS_STARTED,
    LOAD_PERMIT_REGISTER_USERS_SUCCESSFUL,
    LOAD_PERMIT_REGISTER_USERS_FAILED,
} from "./types";
import { User } from "../../models/User";

export function loadPermitRegisterUsersStarted(): PermitAssignmentsActionTypes {
    return {
        type: LOAD_PERMIT_REGISTER_USERS_STARTED,
    };
}

export function loadPermitRegisterUsersSuccessful(permitRegisterUsers: User[]): PermitAssignmentsActionTypes {
    return {
        type: LOAD_PERMIT_REGISTER_USERS_SUCCESSFUL,
        permitRegisterUsers,
    };
}

export function loadPermitRegisterUsersFailed(error: Error): PermitAssignmentsActionTypes {
    return {
        type: LOAD_PERMIT_REGISTER_USERS_FAILED,
        error,
    };
}
